<template>
  <v-card flat style="background-color:#e9e9e9;">
      <v-tabs  fixed-tabs elevation-0  style="background-color:#e9e9e9;">
           <v-tab @change="changetab('Event Master')">
        <v-icon left>
          mdi-bank
        </v-icon>
        Event
      </v-tab>
      <v-tab @change="changetab('Venue Master')">
        <v-icon left>
          mdi-account
        </v-icon>
        Venue
      </v-tab>
      <v-tab @change="changetab('Stand Master')">
        <v-icon left>
          mdi-account-network
        </v-icon>
       Stand
      </v-tab>
        <v-tab-item >
        <event></event>
      </v-tab-item>
        <v-tab-item >
        <venue></venue>
      </v-tab-item>
       <v-tab-item >
        <stand></stand>
      </v-tab-item>
      </v-tabs>
  </v-card>
</template>

<script>
import event from '../masters/EventMaster.vue'
import venue from '../masters/venues.vue'
import stand from '../masters/stand.vue'
export default {
components:{event,venue,stand},
methods:{
  changetab:function(pagename){
      this.$store.commit("setPageTitle", pagename);
  }
}
}
</script>

<style>

</style>